module.exports = __webpack_public_path__ + "img/11_67.6731d711.png";